import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  createCurrenciesStart,
  editCurrencyStart,
  getCurrencyByIdStart
} from '../../../../store/redux-slices/currencies'
import { useEffect, useState } from 'react'
import { getCountriesStart, getTenantCountriesStart } from '../../../../store/redux-slices/fetchData'
import { isTenant } from '../../../../utils/constants'

const useCreateCurrencies = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [params] = useSearchParams()
  const adminId = params.get('adminId')
  const tenantId = params.get('tenantId')
  const { loading, currency } = useSelector((state) => state.currencies)
  const [selectedTab, setSelectedTab] = useState('details')
  const [selectedCountries, setSelectedCountries] = useState([])
  const [myCountries, setMyCountries] = useState([])
  const { countries: SACountries, tenantCountries } = useSelector(state => state.fetch)
  const countries = isTenant ? tenantCountries?.rows : SACountries
  const [search, setSearch] = useState('')

  useEffect(() => {
    isTenant ? dispatch(getTenantCountriesStart()) : dispatch(getCountriesStart({ limit: '', name: '', pageNo: '', isTenant }))
  }, [])

  const setCountries = () => {
    if (countries?.length) {
      const country = countries
        .filter(({ name }) => name?.EN?.toLowerCase().includes(search.toLowerCase()))
        .map(({ name, code }) => ({ name: name?.EN, code }))
      setMyCountries(country)
    }
  }

  useEffect(() => {
    setCountries()
  }, [countries, search])

  const editCurrency = (data) => dispatch(editCurrencyStart(data))
  const createCurrencies = (data) => dispatch(createCurrenciesStart(data))
  const getCurrencyById = (currencyId) => dispatch(getCurrencyByIdStart({ currencyId }))

  const handleCountrySelect = (code) => {
    setSelectedCountries((prev) =>
      prev.includes(code)
        ? prev.filter((item) => item !== code)
        : [code, ...prev]
    )
  }

  return {
    navigate,
    editCurrency,
    createCurrencies,
    loading,
    selectedTab,
    setSelectedTab,
    selectedCountries,
    setSelectedCountries,
    handleCountrySelect,
    myCountries,
    search,
    setSearch,
    adminId,
    tenantId,
    getCurrencyById,
    currency
  }
}

export default useCreateCurrencies
